import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackCompleteAccountSetupClicked = () => {
    return useTrackConversion({
        goal: KameleoonGoalData.CompleteAccountSetupClicked,
    });
};
